<template>
	<div class="header">
		<div>
			<div class="logo">
				<img src="../assets/图片文件夹/路径 7(描边).png" alt="">
			</div>
			<!-- <span class="spans">上海煜豆信息技术有限公司</span> -->
			<img src="../assets/图片文件夹/上海煜豆信息科技有限公司 SHANGHAI YUDOU INFORMATION TECHNOLOGY CO., LTD-1.png" alt=""
				class="spans">
			<div class="navBar">
				<!-- 我们可以直接配置它指向当前的路由路径$route.path -->
				<!-- @select="handleSelect"> -->
				<el-menu router :default-active="$route.path" class="el-menu-demo" mode="horizontal">
					<div class="menuItemBox">
						<el-menu-item index="/">
							<span>首页</span>
						</el-menu-item>
					</div>
					<div class="menuItemBox">
						<el-menu-item index="/product">
							<span>
								产品中心
								<i class="el-icon-arrow-down"></i>
							</span>
						</el-menu-item>
						<ul class="el-menu-item-hover">
							<li class="pt">
								<router-link :to="{path:'/product',query:{random}}">产品中心</router-link>
							</li>
							<li>
								<a @click="routerPointTo('caseMainConChildPro4')">BIM协同管理平台</a>
							</li>
							<li>
								<a @click="routerPointTo('caseMainConChildPro1')">国际协同创新区平台</a>
							</li>
							<li>
								<a @click="routerPointTo('caseMainConChildPro3')">物流追溯平台</a>
							</li>
							<li>
								<a @click="routerPointTo('caseMainConChildPro2')">一网管协同平台</a>
							</li>
							<!-- <li>
								<a @click="routerPointTo('caseMainConChildPro5')">金桥平台</a>
							</li> -->
							<div class="popper__arrow"></div>
						</ul>
					</div>
					<div class="menuItemBox">
						<el-menu-item index="/case">
							<span>
								成功案例
								<!-- <i class="el-icon-arrow-down"></i> -->
							</span>
						</el-menu-item>
						<!-- <ul class="el-menu-item-hover">
							<li class="pt">
								<router-link :to="{path:'/case',query:{random}}">成功案例</router-link>
							</li>
							<li>
								<a @click="routerPointTo('caseMainConChild1')">案例1</a>
							</li>
							<div class="popper__arrow"></div>
						</ul> -->
					</div>
					<div class="menuItemBox">
						<el-menu-item index="/service">
							<span>
								技术服务
								<i class="el-icon-arrow-down"></i>
							</span>
						</el-menu-item>
						<ul class="el-menu-item-hover">
							<li class="pt">
								<router-link :to="{path:'/service',query:{random}}">技术服务</router-link>
							</li>
							<li>
								<a @click="routerPointTo('consult')">方案咨询</a>
							</li>
							<li>
								<!-- <a @click="routerPointTo('project')">定制开发</a> -->
								<a @click="routerPointTo('projectCon')">定制开发</a>
							</li>
							<li>
								<a @click="routerPointTo('bim')">BIM建模</a>
							</li>
							<div class="popper__arrow"></div>
						</ul>
					</div>
					<div class="menuItemBox">
						<el-menu-item index="/about">
							<span>
								关于我们
								<i class="el-icon-arrow-down"></i>
							</span>
						</el-menu-item>
						<ul class="el-menu-item-hover">
							<li class="pt">
								<router-link :to="{path:'/about',query:{random}}">关于我们</router-link>
							</li>
							<li>
								<!-- <a @click="routerPointTo('introduce')">公司介绍</a> -->
								<a @click="routerPointTo('divss')">公司介绍</a>
							</li>
							<li>
								<!-- <a @click="routerPointTo('culture')">企业文化</a> -->
								<a @click="routerPointTo('cultureConss')">企业文化</a>
							</li>
							<li>
								<!-- <a @click="routerPointTo('society')">社会责任</a> -->
								<a @click="routerPointTo('auCSR-list')">社会责任</a>
							</li>
							<li>
								<a @click="routerPointTo('honour')">荣誉资质</a>
							</li>
							<!-- <li>
								<a @click="routerPointTo('newsList')">新闻动态</a>
							</li> -->
							<div class="popper__arrow"></div>
						</ul>
					</div>
					<div class="menuItemBox">
						<el-menu-item index="/joinus">
							<span>
								加入我们
								<i class="el-icon-arrow-down"></i>
							</span>
						</el-menu-item>
						<ul class="el-menu-item-hover">
							<li class="pt">
								<router-link :to="{path:'/joinus',query:{random}}">加入我们</router-link>
							</li>
							<li>
								<a @click="routerPointTo('why')">加入煜豆</a>
							</li>
							<li>
								<a @click="routerPointTo('job')">诚聘英才</a>
							</li>
							<li>
								<a @click="routerPointTo('contactUs')">联系我们</a>
							</li>
							<div class="popper__arrow"></div>
						</ul>
					</div>
				</el-menu>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				random: Date.parse(new Date()), //随机数
			}
		},
		created() { },
		mounted() {
			// localStorage.setItem('pointIdName', 'null') //参数传值 单个
		},
		methods: {
			// 跳转锚点
			routerPointTo(pointIdName) {
				// console.log(pointIdName, "pointIdName")
				// 	localStorage.setItem('pointIdName', pointIdName) //参数传值 单个
				if (pointIdName == 'why' || pointIdName == 'job' || pointIdName == 'contactUs') {
					this.$router.push({
						path: '/joinus',
						// name: 'joinus',
						query: {
							pointIdName: pointIdName,
							random: Date.parse(new Date())
						}
					})
				} else if (pointIdName == 'divss' || pointIdName == 'cultureConss' || pointIdName == 'auCSR-list' ||
					pointIdName == 'honour') {
					this.$router.push({
						path: '/about',
						query: {
							pointIdName: pointIdName,
							random: Date.parse(new Date())
						}
					})
				} else if (pointIdName == 'consult' || pointIdName == 'projectCon' || pointIdName == 'bim') {
					this.$router.push({
						path: '/service',
						query: {
							pointIdName: pointIdName,
							random: Date.parse(new Date())
						}
					})
				} else if (pointIdName == 'caseMainConChild1') {
					this.$router.push({
						path: '/case',
						query: {
							pointIdName: pointIdName,
							random: Date.parse(new Date())
						}
					})
				} else if (pointIdName == 'caseMainConChildPro1' || pointIdName == 'caseMainConChildPro2' || pointIdName ==
					'caseMainConChildPro3' || pointIdName == 'caseMainConChildPro4' || pointIdName ==
					'caseMainConChildPro5') {
					this.$router.push({
						path: '/product',
						query: {
							pointIdName: pointIdName,
							random: Date.parse(new Date())
						}
					})
				}
				// else if (pointIdName == 'newsList') {
				// 	this.$router.push({
				// 		path: '/about',
				// 		query: {
				// 			pointIdName: pointIdName,
				// 			random: Date.parse(new Date()),
				// 		}
				// 	})
				// }
			}
		},
	}
</script>
<style lang="scss" scoped>
	.header {
		height: 60px;
		line-height: 60px;
		width: 100%;
		z-index: 999;
		position: fixed;
		top: 0;
		left: 0;
		background: #fff;
		border-bottom: 1px solid #eee;
	}

	.header>div {
		width: 65%;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.spans {
		height: 50px;
		margin-top: 5px;
		color: #3291f8;
		font-size: 25px;
		font-weight: 600;
		white-space: nowrap;
		float: left;
	}

	.logo {

		text-align: center;
		padding-top: 4.5px;

		img {
			width: 40px;
			height: 40px;
			margin-top: 5px;
		}

	}

	.navBar {
		width: 80%;
	}

	// **************修改nav样式
	.header /deep/ .el-menu.el-menu--horizontal {
		border-bottom: none;
		display: flex;
		justify-content: flex-end;
	}

	.header /deep/ .el-dropdown-menu__item,
	.el-menu-item {
		font-size: 16px;
		// margin-right: 10px;
		color: #32363f;
		border: none;
	}

	.header /deep/ .el-menu-item i {
		color: #32363f;
		font-size: 12px;
		width: 0px;
		font-weight: bold;
	}

	// .header /deep/ .el-menu-item:last-child {
	// 	margin-right: 0px;
	// }

	.header /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
	.header /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
	.header /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover i {
		color: #006fff;
	}

	// .header /deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):hover .el-menu-item-hover {
	// 	display: block;
	// }
	.header /deep/ .menuItemBox {
		border: none;
		margin-right: 10px;
	}

	.header /deep/ .menuItemBox:last-child {
		margin-right: 0px;
	}

	.header /deep/ .menuItemBox:hover .el-menu-item-hover {
		display: block;
	}

	.header /deep/ .el-menu-item.is-active {
		color: #006fff;
		border: none; //选中时去掉border-bottom边框
	}

	.header /deep/ .el-menu-item.is-active i {
		color: #006fff;
	}

	.header /deep/ .el-menu {
		background-color: transparent;
	}

	.header /deep/ .el-menu-item:focus,
	.header /deep/ .el-menu-item:hover {
		// outline: 0;
		// background-color: #ecf5ff;
		background-color: transparent;
	}

	// hover时出现二级菜单
	// .header /deep/ .el-menu--horizontal>.el-menu-item {
	// 	position: relative;
	// }
	.header /deep/ .el-menu--horizontal>.menuItemBox {
		position: relative;
	}

	// .header /deep/ .el-menu--horizontal>.el-menu-item
	.el-menu-item-hover {
		list-style: none;
		position: absolute;
		width: 100%;
		left: 0;
		// top: 65px;
		top: 50px;
		// 修饰样式
		background: #fff;
		color: #606266;
		line-height: 1.4;
		text-align: justify;
		font-size: 14px;
		word-break: break-all;
		padding: 10px 0px 12px;
		border-radius: 5px;
		-moz-border-radius: 5px;
		-ms-border-radius: 5px;
		-o-border-radius: 5px;
		-webkit-border-radius: 5px;
		border: 1px solid #ebebeb;
		box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1), 0 2px 4px 0 rgba(0, 0, 0, .1);
		display: none;
		// display: block;
	}

	.el-menu-item-hover>li {
		text-align: center;
		width: 100%;
		margin: 0 auto;
	}

	.el-menu-item-hover>li a {
		color: #333;
		display: block;
		line-height: 28px;
		font-size: 12px;
		text-decoration: none;
		margin-bottom: 2px;
		cursor: pointer;
	}

	.el-menu-item-hover>li.pt a {
		color: #333;
		display: block;
		line-height: 36px;
		// font-weight: bold;
		font-weight: 600;
		font-size: 14px;
		margin-bottom: 5px;
		border-bottom: 1px #e5e5e5 solid;
	}

	.el-menu-item-hover>li a:hover {
		color: #006fff;
	}

	.popper__arrow {
		top: 0;
		margin-right: 3px;
		border-top-width: 0;
		// ebebeb
		// border-bottom-color: #ebeef5;
		border-bottom-color: #ebebeb;
		border-width: 6px;
		filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .05));
		position: absolute;
		display: block;
		width: 0;
		height: 0;
		border-color: transparent;
		border-style: solid;
		z-index: 9;

	}

	.popper__arrow::after {
		position: absolute;
		display: block;
		width: 0;
		height: 0;
		border-color: transparent;
		border-style: solid;
		top: -18px;
		margin-left: 45px;
		border-top-width: 0;
		border-bottom-color: #fff;
		content: " ";
		border-width: 6px;
	}
</style>